var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"whychoice"},[_c('AdenTitle',{staticClass:"mb-[42px]",attrs:{"titles":['7大特色餐厅，800多道东西方美食免费享用']}}),_vm._v(" "),_c('div',{staticClass:"banner"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }